/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TaskPriority } from './TaskPriority';
import {
    TaskPriorityFromJSON,
    TaskPriorityFromJSONTyped,
    TaskPriorityToJSON,
    TaskPriorityToJSONTyped,
} from './TaskPriority';
import type { TaskStatus } from './TaskStatus';
import {
    TaskStatusFromJSON,
    TaskStatusFromJSONTyped,
    TaskStatusToJSON,
    TaskStatusToJSONTyped,
} from './TaskStatus';

/**
 * Request to update a task
 * @export
 * @interface UpdateClaimTaskRequest
 */
export interface UpdateClaimTaskRequest {
    /**
     * Task title
     * @type {string}
     * @memberof UpdateClaimTaskRequest
     */
    title?: string;
    /**
     * Optional task description
     * @type {string}
     * @memberof UpdateClaimTaskRequest
     */
    description?: string | null;
    /**
     * 
     * @type {TaskStatus}
     * @memberof UpdateClaimTaskRequest
     */
    status?: TaskStatus;
    /**
     * 
     * @type {TaskPriority}
     * @memberof UpdateClaimTaskRequest
     */
    priority?: TaskPriority;
    /**
     * Optional due date for the task
     * @type {Date}
     * @memberof UpdateClaimTaskRequest
     */
    dueDate?: Date | null;
    /**
     * ID of the user assigned to this task
     * @type {number}
     * @memberof UpdateClaimTaskRequest
     */
    assignedTo?: number | null;
}



/**
 * Check if a given object implements the UpdateClaimTaskRequest interface.
 */
export function instanceOfUpdateClaimTaskRequest(value: object): value is UpdateClaimTaskRequest {
    return true;
}

export function UpdateClaimTaskRequestFromJSON(json: any): UpdateClaimTaskRequest {
    return UpdateClaimTaskRequestFromJSONTyped(json, false);
}

export function UpdateClaimTaskRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateClaimTaskRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'status': json['status'] == null ? undefined : TaskStatusFromJSON(json['status']),
        'priority': json['priority'] == null ? undefined : TaskPriorityFromJSON(json['priority']),
        'dueDate': json['dueDate'] == null ? undefined : (new Date(json['dueDate'])),
        'assignedTo': json['assignedTo'] == null ? undefined : json['assignedTo'],
    };
}

export function UpdateClaimTaskRequestToJSON(json: any): UpdateClaimTaskRequest {
    return UpdateClaimTaskRequestToJSONTyped(json, false);
}

export function UpdateClaimTaskRequestToJSONTyped(value?: UpdateClaimTaskRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'description': value['description'],
        'status': TaskStatusToJSON(value['status']),
        'priority': TaskPriorityToJSON(value['priority']),
        'dueDate': value['dueDate'] == null ? undefined : ((value['dueDate'] as any).toISOString()),
        'assignedTo': value['assignedTo'],
    };
}

